module.exports = __webpack_public_path__ + "img/MEDIA062.20d089b3.jpg";